module.exports = __webpack_public_path__ + "561e4b63e9119235465ec88c8c91f2c8.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/ExtraBold/OpenSans-ExtraBold.eot
// module id = 1013
// module chunks = 0